import React from "react";
import TabellaOrariAcq from "./TabellaOrariAcq";
import TabellaOrariAvv from "./TabellaOrariAvv";
import TabellaOrariBR from "./TabellaOrariBR";
import TabellaOrariAdulti from "./TabellaOrariAdulti";
import "../../styles/AccordionEstivi.css"
import TabellaOrariPreParto from "./TabellaPreParto";
import TabellaOrariPreAgo from "./TabellaPreAgo";
import Space from "../../commons/Space";
import FitnessLegenda from "../fitness/FitnessLegenda";
import {Navigate} from "react-router";
import {NavLink} from "react-router-dom";
import SpaceL from "../../commons/SpaceL";


function NuotoCorsiSezioni() {
    return (
        <div className="accordion estivi d-flex flex-column m-auto" id="accordionFlushExample" style={{}}>

            <div className="accordion-item">
                <h2 className="accordion-header d-flex flex-row flex-wrap" id="flush-headingOne" style={{ justifyContent: "center", textAlign: "center" }}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" style={{ backgroundColor: "#73DBC6", color: "#032041" }}>
                        ACQUATICITÀ e AVVIAMENTO <br className="d-block d-sm-none"></br> (6 mesi - 5 anni)
                    </button>

                </h2>
                <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample" >
                    <div className="accordion-body" >
                        <div className="d-flex flex-row flex-wrap" style={{display: "flex", flexDirection: "row"}}>
                            <table className="table table-bordered m-auto" style={{width: "80%", maxWidth: "30em", marginBottom: "20px",}}>
                                <thead className="text-center">
                                <tr >
                                    <th className="header-cell" scope="col" >Sabato</th>
                                </tr>
                                </thead>
                                <tbody >
                                <tr>
                                    <th className="header-cell text-center" colSpan={1} scope="col" style={{color: "#032041", fontStyle: "", fontSize: "14px"}}>ACQUATICITÀ (con e senza genitore)
                                        <br/>6 - 36 mesi</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">9:00 - 9:40</td>
                                </tr>
                                <tr>
                                    <td className="data-cell">9:45 - 10:25</td>
                                </tr>
                                <tr>
                                    <th className="header-cell text-center" colSpan={1} scope="col" style={{color: "#032041", fontStyle: "bold", fontSize: "14px"}}>
                                        AVVIAMENTO
                                        <br/>
                                        3 - 5 anni
                                    </th>
                                </tr>
                                <tr>
                                    <td className="data-cell">10:30 - 11:10</td>
                                </tr>
                                <tr>
                                    <td className="data-cell">11:15 - 11:55</td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" style={{ backgroundColor: "#7FF1BB", color: "#032041" }}>
                        NUOTO BAMBINI E RAGAZZI <br className="d-block d-sm-none"></br> (6 - 14 anni)
                    </button>
                </h2>
                <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table table-bordered m-auto" style={{width: "90%"}}>
                                <thead>
                                <tr>
                                    <th className="header-cell" scope="col">Lun</th>
                                    <th className="header-cell" scope="col">Mar</th>
                                    <th className="header-cell" scope="col">Mer</th>
                                    <th className="header-cell" scope="col">Gio</th>
                                    <th className="header-cell" scope="col">Ven</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">17:45 - 18:30<br/><span className="small" >(dai 10 anni)</span></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">17:45 - 18:30<br/><span className="small">(dai 10 anni)</span></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">18:30 - 19:15</td>
                                    <td className="data-cell">18:30 - 19:15</td>
                                    <td className="data-cell">18:30 - 19:15</td>
                                    <td className="data-cell">18:30 - 19:15</td>
                                    <td className="data-cell">18:30 - 19:15</td>

                                </tr>
                                </tbody>
                            </table>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree" style={{ backgroundColor: "#85D7F6", color: "#032041" }}>
                        NUOTO ADULTI
                    </button>
                </h2>
                <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table table-bordered m-auto" style={{width: "90%"}}>
                                <thead>
                                <tr>
                                    <th className="header-cell" scope="col">Lun</th>
                                    <th className="header-cell" scope="col">Mar</th>
                                    <th className="header-cell" scope="col">Mer</th>
                                    <th className="header-cell" scope="col">Gio</th>
                                    <th className="header-cell" scope="col">Ven</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">11:55 - 12:40</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">11:55 - 12:40</td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">12:45 - 13:30</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">12:45 - 13:30</td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">17:45 - 18:30<br/><span className="small">(dai 10 anni)</span></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">17:45 - 18:30<br/><span className="small">(dai 10 anni)</span></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">19:15 - 20:00</td>
                                    <td className="data-cell">19:15 - 20:00</td>
                                    <td className="data-cell">19:15 - 20:00</td>
                                    <td className="data-cell">19:15 - 20:00</td>
                                    <td className="data-cell">19:15 - 20:00</td>
                                </tr>
                                </tbody>
                            </table>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFour">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour" style={{ backgroundColor: "#F8BCDF", color: "#032041" }}>
                        CORSO PREPARTO
                    </button>
                </h2>
                <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body" style={{}}>
                        <div className="table-container" style={{display: "flex", flexDirection: "row"}}>
                            <table className="table table-bordered m-auto" style={{width: "90%"}}>
                                <thead>
                                <tr>
                                    <th className="header-cell" scope="col">Lun</th>
                                    <th className="header-cell" scope="col">Mer</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">11:00 - 12:00<br/><span className="small">*fino al 24/06</span> </td>
                                    <td className="data-cell">10:45 - 11:45</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <p className="text-center" style={{marginTop: "2em"}}>
                            Il corso prevede una parte di ginnastica a secco e una parte in vasca (acqua alta e acqua bassa)
                            <br/>
                            si richiede buona capacità di galleggiamento
                            <br/>
                            <br/>
                            <b>cosa portare?</b>
                            <br/>
                            abbigliamento ginnico, costume, cuffia, asciugamano, ciabatte
                            <br/>
                            <br/>
                            *richiesto certificato ginecologico
                        </p>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingFive">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive" style={{ backgroundColor: "#F4AFA2", color: "#032041"}}>
                        ACQUAFITNESS
                    </button>
                </h2>
                <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div style={{margin: "0 0 2em 3em"}}><FitnessLegenda color1={"#60A0F6"} label1={"Acqua alta"} color2={"#61D9FB"} label2={"Acqua alta e bassa"} color3={"#FFAEA5"} label3={"Acqua bassa - per chi non sa nuotare"}/></div>
                        <div className="table-container">
                            <table className="table table-bordered m-auto" style={{width: "90%"}}>
                                <thead>
                                <tr>
                                    <th className="header-cell" scope="col">Lun</th>
                                    <th className="header-cell" scope="col">Mar</th>
                                    <th className="header-cell" scope="col">Mer</th>
                                    <th className="header-cell" scope="col">Gio</th>
                                    <th className="header-cell" scope="col">Ven</th>
                                    <th className="header-cell" scope="col">Sab</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontStyle: "bold"}}>Mattino</th>
                                </tr>
                                <tr>
                                    <td className="data-cell vasca-grande" > 10:00 -10:45 <br/> <a style={{color: "black"}}>Acqua Fitness</a></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell vasca-piccola">
                                        10:00 -10:45 <br/> <a style={{color: "black"}}>Soft Water Gag</a>
                                    </td>
                                    <td className="data-cell vasca-grande">10:00 -10:45 <br/> <a style={{color: "black"}}>Acqua Fitness</a></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell solo-grande">
                                        10:15 - 11:00 <br/> <a style={{color: "black"}}>Deep Water</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontStyle: "bold"}}>Intervallo</th>
                                </tr>
                                <tr>
                                    <td className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontSize: "14px"}}>dal 17/06 al 27/06</td>
                                </tr>
                                <tr>
                                    <td className="data-cell vasca-grande">12:40 - 13:25 <br/> Acqua Fitness</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell vasca-grande">12:30 - 13:30 <br/> Acqua Thriathlon</td>
                                    <td className="data-cell vasca-grande">12:40 - 13:25 <br/> Acqua Fitness</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>

                                <tr>
                                    <td className="data-cell vasca-grande">13:30 - 14:15 <br/> Acqua Fitness</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell vasca-grande">13:30 - 14:30 <br/> Acqua Thriathlon</td>
                                    <td className="data-cell vasca-grande">13:30 - 14:15 <br/> Acqua Fitness</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontSize: "14px"}}>dal 03/07 al 26/07</td>
                                </tr>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell vasca-grande">13:00 - 13:45 <br/> Acqua Fitness</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <th className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontStyle: "bold"}}>Sera</th>
                                </tr>
                                <tr>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell vasca-grande">19:15 - 20:00 <br/> Acqua Fitness </td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell vasca-grande">20:05 - 20:45 <br/> Acqua Fitness <br/><span className="small">*fino al 24/06</span></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell vasca-grande">20:30 - 14:15 <br/> Acqua Fitness </td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSix">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix" style={{ backgroundColor: "#FECF40", color: "#032041"}}>
                        FITNESS
                    </button>
                </h2>
                <div id="flush-collapseSix" className="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="table-container">
                            <table className="table table-bordered m-auto" style={{width: "90%"}}>
                                <thead>
                                <tr>
                                    <th className="header-cell" scope="col">Lun</th>
                                    <th className="header-cell" scope="col">Mar</th>
                                    <th className="header-cell" scope="col">Mer</th>
                                    <th className="header-cell" scope="col">Gio</th>
                                    <th className="header-cell" scope="col">Ven</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontStyle: "bold"}}>Mattino</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        9:00 - 10:00 (*) <br/> <a style={{color: "black"}}>Postural Stretching</a>
                                    </td>
                                    <td className="data-cell" rowSpan={2}>
                                        9:00 - 11:00 (*) <br/> <a style={{color: "black"}}>Total Body + Stretching</a>
                                    </td>
                                    <td className="data-cell" rowSpan={2}>
                                        9:00 - 11:00 <br/> <a style={{color: "black"}}>Up Body + Leg Crash</a>
                                    </td>
                                    <td className="data-cell">
                                        9:00 - 10:00 (*) <br/> <a style={{color: "black"}}>Postural Stretching</a>
                                    </td>
                                    <td className="data-cell" rowSpan={2}>
                                        9:00 - 11:00 <br/> <a style={{color: "black"}}>Pilates + Functional Training </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        10:00 - 11:00 (*) <br/> <a style={{color: "black"}}>Postural Stretching</a>
                                    </td>
                                    <td className="data-cell">
                                        10:00 -11:00  (*) <br/> <a style={{color: "black"}}>Postural Stretching</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontStyle: "bold"}}>Intervallo</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        12:45 - 14:15 <br/> <a style={{color: "black"}}>Pilates + Total Body </a>
                                    </td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">
                                        11:45 - 12:45 <br/> <a style={{color: "black"}}>Hatha Yoga </a>
                                    </td>
                                    <td className="data-cell">
                                        12:45 - 14:15 <br/> <a style={{color: "black"}}>Functional Training + Pilates </a>
                                    </td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <th className="header-cell text-center" colSpan={6} scope="col" style={{color: "#032041", fontStyle: "bold"}}>Sera</th>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        19:00 - 19:45 <br/> <a style={{color: "black"}}>Fit Boxe </a>
                                    </td>
                                    <td className="data-cell">
                                        19:00 - 19:45 <br/> <a style={{color: "black"}}>Zumba </a>
                                    </td>
                                    <td className="data-cell">
                                        19:00 - 20:00 <br/> <a style={{color: "black"}}>Pilates</a>
                                    </td>
                                    <td className="data-cell">
                                        19:00 - 19:45 <br/> <a style={{color: "black"}}>Total Body</a>
                                    </td>
                                    <td className="data-cell">
                                        19:00 - 20:00 <br/> <a style={{color: "black"}}>Functional Training</a>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="data-cell">
                                        19:45 - 20:30 <br/> <a style={{color: "black"}}>Functional Training</a>
                                    </td>
                                    <td className="data-cell">
                                        19:45 - 20:30 <br/> <a style={{color: "black"}}>CIRCL Mobility</a>
                                    </td>
                                    <td className="data-cell">
                                        20:00 - 21:00 <br/> <a style={{color: "black"}}>Hatha Yoga</a>
                                    </td>
                                    <td className="data-cell">
                                        19:45 - 20:30 <br/> <a style={{color: "black"}}>Zumba</a>
                                    </td>
                                    <td className="data-cell">
                                        20:00 - 21:00 <br/> <a style={{color: "black"}}>Pilates</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <br/>
                            <p className="text-center">(*) i corsi indicati terminano il 18/07</p>
                        </div>


                    </div>
                </div>
            </div>
            <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingSeven">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven" style={{ backgroundColor: "#DFCCF6", color: "#032041"}}>
                        RUNNERING
                    </button>
                </h2>
                <div id="flush-collapseSeven" className="accordion-collapse collapse" aria-labelledby="flush-headingSeven" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body text-center" style={{fontSize: "20px"}}>
                        Fino al 26 luglio orari e prezzi dei <span></span>
                        <NavLink to={"../Runnering"} style={{color: "black", fontStyle: "bold"}}>corsi Runnering</NavLink>

                        <span> </span>restano invariati
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NuotoCorsiSezioni;
